import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { WorkViewer } from "@/components/WorkViewer";
import { WorkCard } from "@/pages/student/Works";

export default function AdminArchive() {
  const [works, setWorks] = useState([]);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/works").then((r) => setWorks(r.data));
  useEffect(() => { load(); }, []);

  const del = async (w) => {
    if (!window.confirm(`Eliminare “${w.title}” di ${w.author}?`)) return;
    try { await api.delete(`/works/${w.id}`); toast.success("Lavoro eliminato"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  const filtered = useMemo(() => {
    const s = q.toLowerCase();
    return works.filter((w) => `${w.title} ${w.author} ${w.classe}`.toLowerCase().includes(s));
  }, [works, q]);

  return (
    <div>
      <p className="font-mono text-xs uppercase tracking-widest text-[#0D9488] mb-3">Archivio globale</p>
      <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-brand-gradient tracking-tight">Tutti i lavori</h1>
        <div className="flex items-center gap-3 border border-zinc-300 bg-white px-4 h-11 w-full sm:w-80">
          <Search className="w-4 h-4 text-zinc-400" />
          <input data-testid="admin-archive-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Autore, classe, titolo…" className="flex-1 text-sm focus:outline-none" />
        </div>
      </div>
      {filtered.length === 0 && <p className="border border-dashed border-zinc-300 p-12 text-center text-zinc-400" data-testid="admin-archive-empty">Nessun lavoro in archivio</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="admin-global-archive-table">
        {filtered.map((w) => <WorkCard key={w.id} w={w} onOpen={setOpen} onDelete={del} showAuthor />)}
      </div>
      <WorkViewer work={open} onClose={() => setOpen(null)} />
    </div>
  );
}
